<ion-tabs #tabs (ionTabsWillChange)="tabWillChange($event)">
  <ion-tab-bar class="tab-bar" slot="bottom">
    <div
      [style.width.px]="selectedTabBackgroundSize"
      [style.height.px]="selectedTabBackgroundSize"
      [style.transform]="'translateX(' + selectedTabBackgroundOffset + 'px)'"
      class="tab-button-background"
    ></div>

    <ion-tab-button class="tab" data-cy="vendors-tab" tab="vendors" (click)="handleHomePageTabSelected(tabs, $event)">
      <ion-icon class="tab-icon vendors" src="/assets/custom-icons/tab-vendors.svg"></ion-icon>
    </ion-tab-button>

    <ion-tab-button (click)="onOpenCart()" data-cy="cart-tab" class="tab">
      <ion-badge *ngIf="cartItemsCount$ | async as cartItemsCount" class="tab-badge" color="green">{{ cartItemsCount }}</ion-badge>
      <ion-icon class="tab-icon cart" src="/assets/custom-icons/tab-cart.svg"></ion-icon>
    </ion-tab-button>

    <ion-tab-button data-cy="contact-tab" class="tab" tab="contact">
      <ion-icon class="tab-icon contact" src="/assets/custom-icons/tab-contact.svg"></ion-icon>
    </ion-tab-button>

    <ion-tab-button data-cy="account-tab" class="tab" tab="account">
      <ion-badge *ngIf="activeOrdersCount$ | async as activeOrdersCount" class="tab-badge" color="green">{{ activeOrdersCount }}</ion-badge>
      <ion-icon class="tab-icon account" src="/assets/custom-icons/tab-account.svg"></ion-icon>
    </ion-tab-button>
  </ion-tab-bar>
</ion-tabs>
